<script>
    export let progress;
</script>

<div class="progress">
    <div class="bar" style={`width: ${progress * 100}%`}>
        <div class="percentage">
            {(progress * 100.0).toFixed() + "%"}
        </div>
    </div>
</div>

<style>
    .progress {
        position: relative;
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
        background: white;
        height: 1.5em;
    }

    .bar {
        position: absolute;
        top: 0;
        background: var(--title-hsl);
        min-width: 40px;
        height: 100%;
    }

    .percentage {
        position: relative;
        top: 1px;
        width: 100%;
        overflow: hidden;
        color: white;
        font-weight: bold;
        text-align: center;
    }
</style>
